const baseUrl =
  // sever on render.com
  "https://meme-server-hy2j.onrender.com";
// "http://localhost:5000";
export default baseUrl;
